export default {"src":"/_next/static/media/the-gant-aspen.9411863c.svg","height":99,"width":86,"blurWidth":0,"blurHeight":0};